import React from 'react';
import PropTypes from "prop-types";

import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';
import LocationLinkOptions
  from 'components/dashboard/location-links-content/LocationLinkOptions';
import LocationLinkColorSelectors
  from 'components/dashboard/location-links-content/LocationLinkColorSelectors';
import LocationLinkMarkers
  from 'components/dashboard/location-links-content/LocationLinkMarkers';

import './LocationLinkItemExpandedContent.css';


function LocationLinkItemExpandedContent(props) {
  const { item, deleteLocationLink } = props;

  return (
    <div className="location-link-item-expanded-content__component">
      <LocationLinkMarkers linkItem={item} />
      <LocationLinkOptions linkItem={item} />
      <LocationLinkColorSelectors linkItem={item} />
      <div className="delete-mobile">
        <CommonLinkDeleteButton
          key={`location-link-delete-mobile-icon-key-${item.id}`}
          linkItem={item}
          deleteFunction={deleteLocationLink}
        />
      </div>
    </div>
  );
}

LocationLinkItemExpandedContent.propTypes = {
  deleteLocationLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default LocationLinkItemExpandedContent;
